import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

// TODO extend ValidatableInput when new validation is live
export class RadioGroup extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            inputs: ['.m-radioGroup__input'],
            labels: ['.m-radioGroup__label'],
            selectedInput: ':checked',
        };
    }

    domEvents() {
        this.dom.inputs.forEach((input) => {
            input.addEventListener('change', (e) => {
                this.events.emit('change', e.target);
            });
        });
    }

    getValue() {
        return this.dom.el.querySelector(':checked').value;
    }

    setChecked(val) {
        const value = String(val);
        const element = Array.from(this.dom.inputs).find((input) => input.value === value);
        if (!element) return false;

        element.checked = true;
        this.events.emit('change', element);
        return true;
    }

    getPropsFromDom() {
        const options = [...this.dom.labels].map((label, index) => ({
            label: label.innerText ?? '',
            name: this.dom.inputs[index].name ?? '',
            value: this.dom.inputs[index].value ?? '',
            disabled: this.dom.inputs[index].disabled ?? '',
            checked: this.dom.inputs[index].checked ?? '',
        }));

        return {
            options,
        };
    }
}
